import React,{useState} from 'react'
import { Form } from 'react-bootstrap'
import Loader from '../../../loader/Loader'
import Text from '../../../input_filed/Text'
import SelectStatus from '../../../input_filed/SelectStatus'
import SaveButton from '../../../buttons/SaveButton'
import { ToastContainer, toast } from 'react-toastify'
import { useFormik } from 'formik'
import { useDispatch } from 'react-redux'
import { AddBrandRes, AddBrandTodo } from '../../../../redux/slices/master_slice/vehical_brand/AddBrand'
import { BrandSchema } from './Validation'

export default function AddBrandForm(props) {
    const { bool, setBool } = props
    const dispatch = useDispatch()
    const [loading, setLoading] = useState(false)

    const initialValues = {
        brand: '',
        status: ""
    }

    const { values, errors, touched, handleBlur, handleChange, handleSubmit, setFieldValue } = useFormik({
        initialValues: initialValues,
        validationSchema: BrandSchema,

        onSubmit: (values, action) => {
            setLoading(true)
            dispatch(AddBrandTodo(values)).then(() => add_res(action))
        }
    })

    const add_res = (action) => {
        if (AddBrandRes?.success) {
            toast.success(AddBrandRes?.message, { position: "bottom-right" });
            setBool(!bool)
            setLoading(false)
            action.resetForm()
        } else {
            toast.error(AddBrandRes?.message, { position: "bottom-right" });
            setLoading(false)
        }
    }
    return (
        <>
        <Form onSubmit={(e) => { e.preventDefault(); handleSubmit(); }}>
                  <div className='form_layout mt-3'>
                      {loading ?
                          <div className='d-flex justify-content-center p-5'>
                              <Loader />
                          </div> :
                          <div className='row'>
                              <div className='col-md-4'>
                                  <Text
                                      label_name='Brand'
                                      placeholder=''
                                    required={true}
                                      name='brand'
                                      value={values.brand || ''}
                                      onChange={handleChange}
                                      onBlur={handleBlur}
                                      error={errors.brand && touched.brand ? (<span className='text-danger form_label' >{errors.brand}</span>) : null}
                                  />
                              </div>
  
                              <div className='col-md-4'>
                                  <SelectStatus
                                      closeMenu={true}
                                      label_name='Status'
                                      disabled={false}
                                    required={true}
                                      name='status'
                                      defaultValue={''}
                                      onChange={(e) =>
                                          setFieldValue('status', e.value)
                                      }
                                      onBlur={handleBlur}
                                      error={errors.status && touched.status ? (<span className='text-danger form_label' >{errors.status}</span>) : null}
                                  />
                              </div>
                              <div className='col-md-12 text-end mt-2'>
                                  <SaveButton name={'Save'} />
                              </div>
                          </div>}
                  </div>
              </Form>
      </>
    )
}
